import { FiDownload, FiFile } from "react-icons/fi";

import type { CorporateDocument } from "newui/features/Company/types";

interface DocumentCategoryGroupProps {
	title: string;
	documents: CorporateDocument[];
}

export const DocumentCategoryGroup: React.FC<DocumentCategoryGroupProps> = ({
	title,
	documents,
}) => {
	if (documents.length === 0) return null;

	return (
		<div>
			<h3 className="mb-3 text-sm font-semibold text-gray-900">{title}</h3>
			<div className="divide-y divide-gray-100 rounded-lg border border-gray-200">
				{documents.map((doc) => (
					<div
						key={doc.id}
						className="flex items-center justify-between gap-4 px-4 py-3"
					>
						<div className="flex min-w-0 items-center gap-3">
							<FiFile className="shrink-0 text-gray-400" size={18} />
							<div className="min-w-0">
								<p className="truncate text-sm font-medium text-gray-900">
									{doc.name}
								</p>
								{doc.description && (
									<p className="truncate text-xs text-gray-500">
										{doc.description}
									</p>
								)}
							</div>
						</div>
						{doc.storage_path && (
							<a
								href={doc.storage_path}
								target="_blank"
								rel="noopener noreferrer"
								className="shrink-0 rounded-md p-2 text-gray-400 transition-colors hover:bg-gray-50 hover:text-blue-600"
								title={`Download ${doc.name}`}
							>
								<FiDownload size={16} />
							</a>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
